module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid22_980x839.5f85099.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid22_980x839.jpg
// module id = cbC9
// module chunks = 0